// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2yMSX","cardDeck":"styles_cardDeck__uJndt","buttonContainer":"styles_buttonContainer__3sTbH"};